const _temp0 = require("./IMG_1337.jpg");
const _temp1 = require("./IMG_8125.jpg");
const _temp2 = require("./IMG_8978.jpg");
const _temp3 = require("./IMG_8992.jpg");
const _temp4 = require("./IMG_9381.jpg");
const _temp5 = require("./IMG_9457.jpg");
const _temp6 = require("./IMG_9518.jpg");
const _temp7 = require("./IMG_9761.jpg");
module.exports = {
  "IMG_1337": _temp0,
  "IMG_8125": _temp1,
  "IMG_8978": _temp2,
  "IMG_8992": _temp3,
  "IMG_9381": _temp4,
  "IMG_9457": _temp5,
  "IMG_9518": _temp6,
  "IMG_9761": _temp7
}